import React from "react";

interface InfoBoxProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  backgroundColor?: string;
}

export const InfoBox = ({
  children,
  backgroundColor,
  className,
  style,
  ...rest
}: InfoBoxProps) => {
  return (
    <div
      className={`d-flex b-4px ${className}`}
      style={{ background: backgroundColor, ...style }}
      {...rest}
    >
      {children}
    </div>
  );
};
